import React from 'react';
import { LeftOutlined } from '@ant-design/icons';
import { Box, Flex, Heading } from 'theme-ui';
import { useLocation, useNavigate } from 'react-router-dom';
import { useGlobalContext } from 'state/GlobalContext';
import BottomSection from './BottomSection';
import styled from '@emotion/styled';

export type BasePageProps = {
  title: string
  extra?: React.ReactNode
  hideBack?: boolean
}
export const BasePage: React.FC<BasePageProps> = ({ title, extra, hideBack, children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [{ state }] = useGlobalContext();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const onClick = () => {
    navigate(-1);
  }

  return (
    <Container>
      <Flex className="navigation" sx={{maxWidth: 'container', justifyContent: 'space-between', alignItems: 'center'}} mx="auto" my={3} px={[3, 4]}>
        <Flex sx={{alignItems: 'baseline'}}>
          {!hideBack && (
            <Circle mr={10} sx={{ zIndex: 10 }} onClick={onClick}><LeftOutlined /></Circle>
          )}
          <Heading as="h1" variant="title" m={0} my={[null, 18]}>{title}</Heading>
        </Flex>
        {extra}
      </Flex>
      <Box className="content" sx={{maxWidth: 'container'}} mx={[null, 16, 16, "auto"]}>
        {children}
      </Box>
      <Box bg="white" mt={60}>
        <BottomSection park={state.selectedPark} />
      </Box>
    </Container>
  );
};

const Circle = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 28, height: 28, borderRadius: 100, background: '#546D49', color: '#fff',
  cursor: 'pointer',
});

const Container = styled.div`
  margin: 0 auto;
  h1 {
    line-height: 32px;
  }
  .content {
    position: relative;
    top: -64px;
    .card > div:first-of-type:not(.top) {
      margin-top: 64px;
    }
  }
  & .ant-card {
    border-radius: 8px;
  }
`;
